/**
 * @generated SignedSource<<9e38537b172f192cf8eac89f459f2148>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type insuranceServiceUpdateMutation$variables = {
  email: string;
  name: string;
  phoneNumbers?: ReadonlyArray<string> | null | undefined;
  userId: string;
};
export type insuranceServiceUpdateMutation$data = {
  readonly update_insurance_agent: {
    readonly affected_rows: number;
  } | null | undefined;
};
export type insuranceServiceUpdateMutation = {
  response: insuranceServiceUpdateMutation$data;
  variables: insuranceServiceUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "email"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "phoneNumbers"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "email",
            "variableName": "email"
          },
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "name"
          },
          {
            "kind": "Variable",
            "name": "phoneNumbers",
            "variableName": "phoneNumbers"
          }
        ],
        "kind": "ObjectValue",
        "name": "_set"
      },
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_eq",
                "variableName": "userId"
              }
            ],
            "kind": "ObjectValue",
            "name": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "insurance_agent_mutation_response",
    "kind": "LinkedField",
    "name": "update_insurance_agent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "affected_rows",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "insuranceServiceUpdateMutation",
    "selections": (v4/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "insuranceServiceUpdateMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "29226cc59e0777b313057d2acc5e65b5",
    "id": null,
    "metadata": {},
    "name": "insuranceServiceUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation insuranceServiceUpdateMutation(\n  $userId: String!\n  $email: String!\n  $name: String!\n  $phoneNumbers: [String!]\n) {\n  update_insurance_agent(where: {id: {_eq: $userId}}, _set: {email: $email, name: $name, phoneNumbers: $phoneNumbers}) {\n    affected_rows\n  }\n}\n"
  }
};
})();

(node as any).hash = "2ef9ef878e4b5fd568c49602e863be42";

export default node;
